import { render, staticRenderFns } from "./PasswordRecovery.vue?vue&type=template&id=0bc1934e&scoped=true"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecovery.vue?vue&type=style&index=0&id=0bc1934e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1934e",
  null
  
)

export default component.exports